var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heading-table"},[_c('p',{staticClass:"heading-table__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"heading-table__sub"},[_vm._v(_vm._s(_vm.subTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }